<div class="container intro-wizard-container">

    <!-- Slide 1 -->
    <ng-container *ngIf="currentStep === 0">
        <div class="section">
            <h1 class="title gradient-text m-0 m-b-8">{{getGreetingMessage()}}</h1>
            <h2 class="subtitle m-0 m-b-16">{{'INTRO_WIZARD_TITLE_TEXT' | translate}}</h2>
            <div class="slide-body m-b-8">
              <span class="icon display-flex">
                  <img src="./assets/images/intro.svg" width="18" alt="Intro" title="{{'INTRO_WIZARD_INTRO_TOOLTIP' | translate}} "/>
              </span>
              <span><strong>{{'INTRO_WIZARD_INTRO_TITLE_TEXT' | translate}}</strong></span>
            </div>
            <div class="accordion-body">
              <span [innerHtml]="'INTRO_SLIDES_INTRO_CONTENT' | translate"></span>
            </div>
          </div>
    </ng-container>
  
    <!-- Slide 2 -->
    <ng-container *ngIf="currentStep === 1">
        <div class="section">
            <h1 class="title gradient-text m-0 m-b-8">{{getGreetingMessage()}}</h1>
            <h2 class="subtitle  m-0 m-b-16">{{'INTRO_WIZARD_TITLE_TEXT' | translate}}</h2>
          <div class="slide-body m-b-8">
              <span class="icon display-flex">
                  <img src="./assets/images/Disclaimer.svg" width="18" alt="Disclaimer" title="{{'INTRO_WIZARD_DISCLAIMER_TITLE_TEXT' | translate}}"/>
              </span>
              <span><strong>{{'INTRO_WIZARD_DISCLAIMER_TITLE_TEXT' | translate}}</strong></span>
            </div>
            <div class="accordion-body">
              <span [innerHtml]="'INTRO_WIZARD_DISCLAIMER_CONTENT' | translate"></span>
            </div>
          </div>
    </ng-container>
  
    <!-- Slide 3 -->
    <ng-container *ngIf="currentStep === 2">
        <div class="section">
            <h1 class="title gradient-text m-0 m-b-8">{{getGreetingMessage()}}</h1>
            <h2 class="subtitle  m-0 m-b-16">{{'INTRO_WIZARD_TITLE_TEXT' | translate}}</h2>
             <div class="slide-body m-b-8">
              <span class="icon display-flex">
                  <img src="./assets/images/tips.svg" width="18" alt="Tips" title="{{'INTRO_WIZARD_TIPS_TITLE_TEXT' | translate}}"/>
              </span>
              <span><strong>{{'INTRO_WIZARD_TIPS_TITLE_TEXT' | translate}}</strong></span>
            </div>
            <div class="accordion-body">
              <span [innerHtml]="'INTRO_WIZARD_TIPS_CONTENT' | translate"></span>
            </div>
          </div>
    </ng-container>
  
    <!-- Slide 4 -->
    <ng-container *ngIf="currentStep === 3">
      <div class="section">
         <h1 class="title gradient-text m-0 m-b-8">{{getGreetingMessage()}}</h1>
        <p class="intro-setting-text m-0 m-b-16">{{'INTRO_SLIDES_SUBTITLE_TEXT' | translate}}</p>
    <div class="accordion-body last-step">
        <label class="setting-module-label">{{'INTRO_SLIDES_MODULE_TEXT' | translate}}</label>
        <div class="radio-group">
          <label class="custom-radio" *ngFor="let option of vectorDbDatasets">
            <input type="radio" name="option" 
            [value]="option.value" 
            (change)="onDatasetSelect(option)"
             [disabled]="isRadioDisabled" 
             [checked]="option === vectorDbDatasets[0] && !isRadioDisabled">
            <span class="radio-label">{{ option.name | translate }}</span>
          </label>
        </div>
          
        <p *ngIf="showSlider" class="note m-b-32">{{'INTRO_SLIDES_MODULE_CARD_NOTE' | translate}}</p>
  
        <label *ngIf="showSlider" class="setting-module-label ">
        {{'INTRO_SLIDES_SOURCES_TITLE_TEXT' | translate}}
        </label>
        <div class="show-sources-container m-b-8" *ngIf="showSlider">
            <label class="switch">
                <input disabled type="checkbox" [(ngModel)]="showSources" (change)="onToggleChange()" />
                <span class="slider"></span>
            </label>
            <span class="slider-label">{{'INTRO_SLIDES_SOURCES_TEXT' | translate}}</span>
        </div>
        <p class="note">{{'INTRO_SLIDES_MODULE_CARD_NOTE' | translate}}</p>
        </div>
      </div>
    </ng-container>
  
    <!-- Footer with buttons -->
    <div class="footer">
      <div>
        <button class="btn skip" (click)="skipIntroMethod()">{{'SKIP_BUTTON_TEXT' | translate}}</button>
      </div>
  
      <div class="progress">
        <span *ngFor="let dot of [].constructor(totalSteps); let i = index"
              [class]="getDotClass(i)"></span>
      </div>

      <div>
        <button class="btn next" (click)="nextStep()">{{'NEXT_BUTTON_TEXT' | translate}}</button>
      </div>
    </div>
  </div>
  